import { urlWithQuery } from '~/utils/url';
import { BaseRestRepository } from './baseRestRepository';
import type { CheckIdentity, PaginatedChecksDto, HydratedCheckDto, NextCheckNumberDto } from '~/swagger/portal/Api';

export type ChecksFilter = {
  page?: number;
  pageSize?: number;
  checkIdentity?: CheckIdentity;
  vendorId?: string;
  ownerId?: string;
  bankAccountId?: string;
  memo?: string;
  transactionId?: string;
};

export const BASE_URL = '/api/checks';
export class ChecksRepository extends BaseRestRepository {
  public async getChecks(filter?: ChecksFilter): Promise<PaginatedChecksDto> {
    const url = urlWithQuery(BASE_URL, filter);
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async getCheck(checkId: string): Promise<HydratedCheckDto> {
    const url = `${BASE_URL}/${checkId}`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async deleteCheck(checkId: string): Promise<void> {
    const url = `${BASE_URL}/${checkId}`;
    await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
  }
  public async getNextCheckNumber(): Promise<NextCheckNumberDto> {
    const url = `${BASE_URL}/next-check-number`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async updateNextCheckNumber(payload: NextCheckNumberDto): Promise<void> {
    const url = `${BASE_URL}/next-check-number`;
    await this.fetchWithAuth(url, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
  }
}

export const checksRepository = new ChecksRepository();
